import React, {KeyboardEventHandler, MutableRefObject} from 'react';
import {BoxProps} from '@material-ui/core/Box';
import TextField, {TextFieldProps} from '@material-ui/core/TextField/TextField';

import {StackProps} from '../../layout/layout.styled';
import {FormControl} from '../form-control/form-control.styles';

export type TextInputFormControlProps = {
    labelText: string
    'data-testid'?: string
    stackProps?: StackProps
    textFieldProps?: TextFieldProps
    labelProps?: BoxProps
    inputRef?: MutableRefObject<any>
    onEnterKey?: KeyboardEventHandler
    onChange?: (e: any) => any
}

export const TextInputFormControl = ({
    'data-testid': dataTestId = 'TextInputFormControl',
    onEnterKey,
    labelText,
    textFieldProps,
    labelProps,
    stackProps,
    inputRef,
    onChange
}: TextInputFormControlProps) => {
    const handleKeyPress: KeyboardEventHandler = (event) => {
        if (!onEnterKey) return;

        if (event.key === 'Enter') {
            event.preventDefault();
            onEnterKey(event);
        }
    };

    return (
        <FormControl
            data-testid={dataTestId}
            labelText={labelText}
            labelProps={labelProps}
            {...stackProps}
        >
            <TextField
                onChange={onChange}
                variant={'outlined'}
                inputRef={inputRef}
                onKeyPress={handleKeyPress}
                {...textFieldProps}
            />
        </FormControl>
    );
};
